import Image from 'next/image';
import Link from 'next/link';
import React from 'react';
import MWSVG from './common/svg';
import Script from 'next/script';
import moment from 'moment';
import { isProduction } from '@/utils/common-helpers';

const FooterBasics = () => {
    return (
        <div className="container relative z-50 pt-0 lg:container md:mx-auto pb-50 lg:py-50">
            <div className="mb-[45px]" data-aos="fade-up" data-aos-duration="700" data-aos-delay="150">
                <div className="grid md:grid-cols-2 lg:gap-10 md:gap-10 lg:grid lg:grid-cols-4 gap-8">
                    <div className="shine">
                        {isProduction() ? (
                            <Link href="/">
                                <Image
                                    src="/img/img-footer-logo@2x.webp"
                                    width={200}
                                    height={52}
                                    alt="Moweb"
                                    title="Moweb"
                                    loading="lazy"
                                    quality={100}
                                    className="dark:hidden"
                                />
                                <Image
                                    src="/img/img-header-logo.svg"
                                    width={200}
                                    height={52}
                                    alt="Moweb"
                                    title="Moweb"
                                    loading="lazy"
                                    quality={100}
                                    className="hidden dark:block"
                                />
                            </Link>
                        ) : (
                            <Link href="/" rel="nofollow">
                                <Image
                                    src="/img/img-footer-logo@2x.webp"
                                    width={200}
                                    height={52}
                                    alt="Moweb"
                                    title="Moweb"
                                    loading="lazy"
                                    quality={100}
                                    className="dark:hidden"
                                />
                                <Image
                                    src="/img/img-header-logo.svg"
                                    width={200}
                                    height={52}
                                    alt="Moweb"
                                    title="Moweb"
                                    loading="lazy"
                                    quality={100}
                                    className="hidden dark:block"
                                />
                            </Link>
                        )}
                    </div>
                    <Link href={'https://clutch.co/profile/moweb-technologies-private#summary'} target="_blank" rel="nofollow">
                        <MWSVG id="img-clutch-footer" svgClassName="!w-[200px] !h-[46px]" />
                    </Link>
                    <Link href={'https://www.topdevelopers.co/profile/Moweb-Technologies'} target="_blank" rel="nofollow">
                        <Image
                            src="/img/img-topdevelopers@2x.webp"
                            width={180}
                            height={44}
                            alt="TopDevelopers"
                            title="TopDevelopers"
                            loading="lazy"
                            quality={100}
                        />
                    </Link>
                    <Link href={'https://www.goodfirms.co/company/moweb-technologies'} target="_blank" rel="nofollow">
                        <Image
                            src="/img/img-goodfirms.webp"
                            width={180}
                            height={29}
                            alt="GoodFirms"
                            title="GoodFirms"
                            loading="lazy"
                            quality={100}
                        />
                    </Link>
                </div>
            </div>
            <div className="grid pb-3 md:grid-cols-2 lg:gap-10 md:gap-10 lg:grid lg:grid-cols-4">
                <div
                    className="mb-30 md:mb-0 md:col-span-1 lg:col-span-1"
                    data-aos="fade-up"
                    data-aos-duration="700"
                    data-aos-delay="170"
                >
                    <div className="mb-5">
                        <p className="footer-title company-title text-textcolor dark:text-light">Company</p>
                        <hr className="opacity-10 footer-hr bg-secondary dark:bg-[#3C4561] dark:opacity-100" />
                        <ul className="footer-nav text-secondary dark:text-light company-nav">
                            <li>
                                <Link href={'/about-us'} className="nav-link">
                                    About Us
                                </Link>
                            </li>
                            <li>
                                <Link href={'/blog'} className="nav-link">
                                    Blog
                                </Link>
                            </li>
                            <li>
                                <Link href={'/careers'} className="nav-link">
                                    Careers
                                </Link>
                            </li>
                            <li>
                                <Link href={'/privacy-policy'} className="nav-link">
                                    Privacy Policy
                                </Link>
                            </li>
                            <li>
                                <Link href={'/contact-us'} className="nav-link">
                                    Contact Us
                                </Link>
                            </li>
                        </ul>
                    </div>
                    <div className="mb-5">
                        <p className="footer-title company-title text-textcolor dark:text-light">Work</p>
                        <hr className="opacity-10 footer-hr bg-secondary dark:bg-[#3C4561] dark:opacity-100" />
                        <ul className="footer-nav text-secondary dark:text-light company-nav">
                            <li>
                                <Link href={'/work'} className="nav-link">
                                    Portfolio
                                </Link>
                            </li>
                            <li>
                                <Link href={'/case-studies'} className="nav-link">
                                    Case Studies
                                </Link>
                            </li>
                            <li>
                                <Link href={'/testimonials'} className="nav-link">
                                    Client Testimonials
                                </Link>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <p className="footer-title company-title text-textcolor dark:text-light">Industries</p>
                        <hr className="opacity-10 footer-hr bg-secondary dark:bg-[#3C4561] dark:opacity-100" />
                        <ul className="footer-nav text-secondary dark:text-light company-nav">
                            <li>
                                <Link href={'/supply-chain-software-development'} className="nav-link">
                                    Supply Chain Management
                                </Link>
                            </li>
                            <li>
                                <Link href={'/agriculture-software-development'} className="nav-link">
                                    Agriculture
                                </Link>
                            </li>
                            <li>
                                <Link href={'/fintech-software-development'} className="nav-link">
                                    Fintech
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
                <div
                    className="mb-3 md:col-span-1 lg:col-span-1 lg:mb-0 md:mb-0"
                    data-aos="fade-up"
                    data-aos-duration="700"
                    data-aos-delay="200"
                >
                    <p className="footer-title services-title text-textcolor dark:text-light">Services</p>
                    <hr className="opacity-10 footer-hr bg-secondary dark:bg-[#3C4561] dark:opacity-100" />
                    {/* <!-- footer-nav text-secondary --> */}
                    <ul className="footer-nav text-secondary dark:text-light">
                        <li>
                            <Link href={'/enterprise-software-development'} className="nav-link">
                                Enterprise Software Development
                            </Link>
                        </li>
                        <li>
                            <Link href={'/mobile-app-development'} className="nav-link">
                                Mobile App Development
                            </Link>
                        </li>
                        <li>
                            <Link href={'/web-development'} className="nav-link">
                                Web Development
                            </Link>
                        </li>
                        <li>
                            <Link href={'/ecommerce-development'} className="nav-link">
                                eCommerce Development
                            </Link>
                        </li>
                        <li>
                            <Link href={'/cms-development'} className="nav-link">
                                CMS Development
                            </Link>
                        </li>
                        <li>
                            <Link href={'/ai-ml-development-services'} className="nav-link">
                                AI and ML Development
                            </Link>
                        </li>
                        <li>
                            <Link href={'/business-analysis-service-baaas'} className="nav-link">
                                Business Analysis
                            </Link>
                        </li>
                        <li>
                            <Link href={'/data-engineering-services'} className="nav-link">
                                Data Engineering Services
                            </Link>
                        </li>
                        <li>
                            <Link href={'/ui-ux-design'} className="nav-link">
                                UI/UX Design
                            </Link>
                        </li>
                        <li>
                            <Link href={'/digital-marketing'} className="nav-link">
                                Digital Marketing
                            </Link>
                        </li>
                        <li>
                            <Link href={'/devops-services'} className="nav-link">
                                DevOps
                            </Link>
                        </li>
                        <li>
                            <Link href={'/simpro-development'} className="nav-link">
                                Simpro
                            </Link>
                        </li>
                        <li>
                            <Link href={'/odoo'} className="nav-link">
                                Odoo
                            </Link>
                        </li>
                        <li>
                            <Link href={'/software-testing-qa-services'} className="nav-link">
                                QA Services
                            </Link>
                        </li>
                    </ul>
                    {/* <!-- footer-nav text-secondary --> */}
                </div>
                <div
                    className="mb-3 md:col-span-1 lg:col-span-1 lg:mb-0 md:mb-0"
                    data-aos="fade-up"
                    data-aos-duration="700"
                    data-aos-delay="200"
                >
                    <p className="footer-title md:block text-textcolor">Technologies</p>
                    <hr className="mr-0 opacity-10 footer-hr md:-mr-10 lg:-mr-10 bg-secondary dark:bg-[#3C4561] dark:opacity-100" />
                    {/* <hr className="hidden md:block mt-2.5 mb-2.5 -mx-10 opacity-10 bg-secondary" /> */}
                    {/* <!-- footer-nav text-secondary --> */}
                    <ul className="footer-nav text-secondary dark:text-light">
                        <li>
                            <Link href={'/android-app-development'} className="nav-link">
                                Android App Development
                            </Link>
                        </li>
                        <li>
                            <Link href={'/ios-app-development'} className="nav-link">
                                iOS App Development
                            </Link>
                        </li>
                        <li>
                            <Link href={'/flutter-app-development'} className="nav-link">
                                Flutter App Development
                            </Link>
                        </li>
                        <li>
                            <Link href={'/angularjs-development'} className="nav-link">
                                Angular Development
                            </Link>
                        </li>
                        <li>
                            <Link href={'/reactjs-development'} className="nav-link">
                                ReactJS Development
                            </Link>
                        </li>
                        <li>
                            <Link href={'/vuejs-development'} className="nav-link">
                                Vue.js Development
                            </Link>
                        </li>
                        <li>
                            <Link href={'/nodejs-development'} className="nav-link">
                                Node js Development
                            </Link>
                        </li>
                        <li>
                            <Link href={'/laravel-development'} className="nav-link">
                                Laravel Development
                            </Link>
                        </li>
                        <li>
                            <Link href={'/django-development'} className="nav-link">
                                Django Development
                            </Link>
                        </li>
                        <li>
                            <Link href={'/full-stack-development'} className="nav-link">
                                Full Stack Development
                            </Link>
                        </li>
                        <li>
                            <Link href={'/mean-stack-development'} className="nav-link">
                                MEAN Stack Development
                            </Link>
                        </li>
                        <li>
                            <Link href={'/mern-stack-development'} className="nav-link">
                                MERN Stack Development
                            </Link>
                        </li>
                        <li>
                            <Link href={'/shopify-development'} className="nav-link">
                                Shopify Development
                            </Link>
                        </li>
                        <li>
                            <Link href={'/magento-development'} className="nav-link">
                                Magento Development
                            </Link>
                        </li>
                    </ul>
                    {/* <!-- footer-nav text-secondary --> */}
                </div>
                <div className="md:col-span-1 lg:col-span-1" data-aos="fade-up" data-aos-duration="700" data-aos-delay="200">
                    <p className="hidden footer-title md:invisible md:block text-textcolor">Technologies</p>
                    <hr className="hidden md:block mt-2.5 mb-2.5 opacity-10 bg-secondary dark:bg-[#3C4561] dark:opacity-100" />
                    {/* <!-- footer-nav text-secondary --> */}
                    <ul className="footer-nav text-secondary dark:text-light">
                        <li>
                            <Link href={'/opencart-development'} className="nav-link">
                                OpenCart Development
                            </Link>
                        </li>
                        <li>
                            <Link href={'/woocommerce-development'} className="nav-link">
                                WooCommerce Development
                            </Link>
                        </li>
                        <li>
                            <Link href={'/wordpress-development'} className="nav-link">
                                WordPress Development
                            </Link>
                        </li>
                        <li>
                            <Link href={'/ionic-app-development'} className="nav-link">
                                Ionic App Development
                            </Link>
                        </li>
                        <li>
                            <Link href={'/jquery-app-development'} className="nav-link">
                                jQuery Development
                            </Link>
                        </li>
                        <li>
                            <Link href={'/codeigniter-development'} className="nav-link">
                                CodeIgniter Development
                            </Link>
                        </li>
                        <li>
                            <Link href={'/php-development'} className="nav-link">
                                PHP Development
                            </Link>
                        </li>
                    </ul>
                    {/* <!-- footer-nav text-secondary --> */}
                </div>
            </div>
            <div className="mb-12 text-center lg:mb-0" data-aos="fade-up" data-aos-duration="700" data-aos-delay="200">
                <hr className="opacity-10 footer-hr-spacing bg-secondary dark:bg-[#3C4561] dark:opacity-100" />
                <div className="flex justify-between items-center flex-wrap gap-2.5">
                    <p className="mb-0">
                        <a
                            href="//www.dmca.com/Protection/Status.aspx?ID=dc16c057-0fc6-4a89-8636-c8d4e181e80f"
                            title="DMCA.com Protection Status"
                            className="dmca-badge"
                            target="__blank"
                            rel="noopener noreferrer nofollow"
                        >
                            <Image
                                src="https://images.dmca.com/Badges/dmca-badge-w200-5x1-07.png?ID=dc16c057-0fc6-4a89-8636-c8d4e181e80f"
                                alt="DMCA.com Protection Status"
                                height={40}
                                width={200}
                            />
                        </a>
                        {process.env.NODE_ENV === 'production' && (
                            <Script 
                                src="https://images.dmca.com/Badges/DMCABadgeHelper.min.js"
                                integrity="sha384-B0Q2xsxY6TBmQAlXPu7f028jP1jFYsgxQVwjNss/TnFAnrbPbT+wYcPc+YVWxppe"
                                crossOrigin="anonymous"
                                strategy="lazyOnload"
                                referrerPolicy="no-referrer"
                                onError={(e) => {
                                    // DMCA script failed to load - this is expected due to CORS policy
                                    console.warn('DMCA badge script could not be loaded due to CORS policy');
                                }}
                            />
                        )}
                    </p>
                    <p className="my-4 font-normal fs-md md:my-0">© Moweb Limited 2008 - {moment().format('yyyy')}</p>
                    <div className="socialclr">
                        <ul>
                            <li>
                                <Link
                                    target="_blank"
                                    rel="nofollow"
                                    title="Facebook"
                                    href="https://www.facebook.com/mowebtech"
                                    className="me-4 socialfb"
                                >
                                    <MWSVG id="img-facebook-black" />
                                </Link>
                            </li>
                            <li>
                                <Link
                                    target="_blank"
                                    rel="nofollow"
                                    title="Twitter"
                                    href="https://twitter.com/mowebtech"
                                    className="me-4 socialtw"
                                >
                                    <MWSVG id="img-twitter-black" />
                                </Link>
                            </li>
                            <li>
                                <Link
                                    target="_blank"
                                    rel="nofollow"
                                    title="Linkedin"
                                    href="https://www.linkedin.com/company/moweb-technologies-pvt-ltd"
                                    className="me-4 socialln"
                                >
                                    <MWSVG id="img-linkedin-black" />
                                </Link>
                            </li>
                            <li>
                                <Link
                                    target="_blank"
                                    rel="nofollow"
                                    title="Instagram"
                                    href="https://www.instagram.com/mowebtechnologies/"
                                    className="socialinsta"
                                >
                                    <MWSVG id="img-insta-black" />
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FooterBasics;
